import React from 'react';
import PropTypes from 'prop-types';
import StoreLogo from '@prisjakt/ui-store-logo';
import Rating from '@prisjakt/ui-rating';
import RatingHelper from '@prisjakt/ui-rating/src/rating-helper';
import shallowEqual from 'shallowequal';

import * as S from './styles';

const countTranslation = {
  domain: 'product',
  key: 'prices.n-ratings',
};

const StoreInfoColumn = React.memo(
  ({ store, userReviewSummary }) => {
    const rating = RatingHelper.convert(userReviewSummary.rating, 1);
    return (
      <S.StoreInfo layout="vertical">
        <S.StoreInfoTitle>{store.name}</S.StoreInfoTitle>
        <StoreLogo
          name={store.name}
          storeId={store.id}
          featured={store.featured}
          hasImage={store.hasLogo}
          variant="PRICE_LIST"
        />
        {rating && rating.whole > 0 && (
          <S.RatingContainer data-rating={rating.rounded}>
            <Rating
              hide={userReviewSummary.count === 0}
              size="small"
              secondaryColors={!store.featured}
              count={userReviewSummary.countTotal}
              countTranslation={countTranslation}
              rate={userReviewSummary.rating}
              showCounter={false}
            />
          </S.RatingContainer>
        )}
      </S.StoreInfo>
    );
  },
  (prevProps, nextProps) => {
    const {
      store: prevStore,
      userReviewSummary: prevReview,
      ...prevRest
    } = prevProps;
    const {
      store: nextStore,
      userReviewSummary: nextReview,
      ...nextRest
    } = nextProps;
    const {
      name: prevName,
      hasLogo: prevHasLogo,
      featured: prevFeatured,
    } = prevStore;
    const {
      name: nextName,
      hasLogo: nextHasLogo,
      featured: nextFeatured,
    } = nextStore;
    return (
      shallowEqual(prevRest, nextRest) &&
      shallowEqual(prevReview, nextReview) &&
      prevName === nextName &&
      prevHasLogo === nextHasLogo &&
      prevFeatured === nextFeatured
    );
  }
);

const { shape, string, number, bool } = PropTypes;

StoreInfoColumn.propTypes = {
  store: shape({
    id: number,
    name: string,
    hasLogo: bool,
    featured: bool,
  }).isRequired,
  userReviewSummary: shape({
    count: number,
    countTotal: number,
    rating: number,
  }),
};

StoreInfoColumn.defaultProps = {
  userReviewSummary: undefined,
};

export default StoreInfoColumn;
